<template>
    <div ref="root">
        <div
            class="album__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="album__inner module__inner">
                <div class="album__inner--main module__inner--main">
                    <div
                        class="album__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle || module.data.text1"
                    >
                        <div class="album__inner-col module__inner-col">
                            <div class="album__header module__header">
                                <h2
                                    class="album__title module__title font-h2 color-h2"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="album__subtitle module__subtitle font-h3 color-h3"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                                <div
                                    class="album__text module__text font-p color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text1"
                                    v-html="module.data.text1"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="album__inner-row module__inner-row"
                        v-if="items && Array.isArray(items) && items.length > 0"
                    >
                        <div class="album__inner-col module__inner-col">
                            <div
                                class="album__images-container"
                                v-bind:class="{
                                    container__boxed: [1, 2, 3].includes(module.layout.type)
                                }"
                            >
                                <div
                                    class="album__preview-image"
                                    v-if="[1].includes(module.layout.type)"
                                >
                                    <a
                                        class="album__btn-lightgallery-preview album__btn-lightgallery lightgallery"
                                        v-if="
                                            items[getPreviewImageIndex] &&
                                                items[getPreviewImageIndex].data &&
                                                items[getPreviewImageIndex].data.image &&
                                                items[getPreviewImageIndex].data.image.id
                                        "
                                        :href="
                                            generateMediaUrl({
                                                id: items[getPreviewImageIndex].data.image.id
                                            })
                                        "
                                        :data-lightgallery-group="module.id"
                                    >
                                        <div
                                            class="imageslider__bg-image"
                                            v-if="
                                                items[getPreviewImageIndex] &&
                                                    items[getPreviewImageIndex].data &&
                                                    items[getPreviewImageIndex].data.image &&
                                                    items[getPreviewImageIndex].data.image.id
                                            "
                                        >
                                            <app-moduleimage
                                                :data="items[getPreviewImageIndex].data.image"
                                                :tag="'div'"
                                                :custom-class="'image-container--preview'"
                                            ></app-moduleimage>
                                        </div>
                                    </a>
                                </div>
                                <ul
                                    class="album__thumbnails"
                                    v-if="[1].includes(module.layout.type)"
                                    v-bind:class="{
                                        'album__thumbnails--scrollable':
                                            [1].includes(module.layout.type) && items.length > 8
                                    }"
                                >
                                    <li
                                        class="album__thumbnail-item "
                                        v-for="(image__value, image__key) in items"
                                        v-bind:key="image__key"
                                        v-bind:thumbnail-index="image__key"
                                        v-on:click="setPreviewImageIndex(image__key)"
                                    >
                                        <a
                                            class="album__btn-lightgallery-thumbnail album__btn-lightgallery-thumbnail--desktop album__btn-lightgallery lightgallery"
                                            v-if="
                                                image__value.data &&
                                                    image__value.data.image &&
                                                    image__value.data.image.id
                                            "
                                            :data-lightgallery-group="
                                                image__key !== 0 ? module.id : ''
                                            "
                                            :data-group="module.id"
                                            :href="
                                                generateMediaUrl({
                                                    id: image__value.data.image.id
                                                })
                                            "
                                        >
                                        </a>
                                        <div
                                            class="imageslider__bg-image"
                                            v-if="
                                                image__value.data &&
                                                    image__value.data.image &&
                                                    image__value.data.image.id
                                            "
                                        >
                                            <a
                                                class="album__btn-lightgallery-thumbnail album__btn-lightgallery-thumbnail--mobile album__btn-lightgallery lightgallery"
                                                v-if="
                                                    image__value.data &&
                                                        image__value.data.image &&
                                                        image__value.data.image.id
                                                "
                                                :data-lightgallery-group="module.id + '42'"
                                                :href="
                                                    generateMediaUrl({
                                                        id: image__value.data.image.id
                                                    })
                                                "
                                            >
                                            </a>
                                            <app-moduleimage
                                                :data="image__value.data.image"
                                                :width="180"
                                                :tag="'div'"
                                                :custom-class="
                                                    'album__thumbnail-image border-color' +
                                                        (image__key === getPreviewImageIndex
                                                            ? ' album__thumbnail-image--active'
                                                            : '')
                                                "
                                            ></app-moduleimage>
                                        </div>
                                    </li>
                                    <li
                                        class="album__thumbnails--covering bg-color-linear-gradient"
                                        v-if="[1].includes(module.layout.type) && items.length > 8"
                                    ></li>
                                </ul>
                                <div
                                    class="slider"
                                    v-if="
                                        [2, 3].includes(module.layout.type) &&
                                            items &&
                                            Array.isArray(items) &&
                                            items.length > 0
                                    "
                                    ref="slider"
                                    :disable-dragging="
                                        ([2].includes(module.layout.type) && items.length <= 4) ||
                                            ([3].includes(module.layout.type) && items.length <= 9)
                                    "
                                    per-page="1"
                                    per-page-lg="1"
                                    per-page-md="1"
                                    per-page-sm="1"
                                >
                                    <ul class="album__thumbnails">
                                        <li
                                            class="album__thumbnail-item "
                                            v-for="(group__value, group__key) in [2].includes(
                                                module.layout.type
                                            )
                                                ? imagesInFourGroups
                                                : imagesInNineGroups"
                                            v-bind:key="group__key"
                                        >
                                            <div
                                                v-for="(image__value, image__key) in group__value"
                                                v-bind:key="image__key"
                                            >
                                                <a
                                                    class="album__btn-lightgallery lightgallery"
                                                    v-if="
                                                        image__value.data &&
                                                            image__value.data.image &&
                                                            image__value.data.image.id
                                                    "
                                                    :data-lightgallery-group="module.id"
                                                    :href="
                                                        generateMediaUrl({
                                                            id: image__value.data.image.id
                                                        })
                                                    "
                                                >
                                                    <div
                                                        class="imageslider__bg-image"
                                                        v-if="
                                                            image__value.data &&
                                                                image__value.data.image &&
                                                                image__value.data.image.id
                                                        "
                                                    >
                                                        <app-moduleimage
                                                            v-if="[2].includes(module.layout.type)"
                                                            :data="image__value.data.image"
                                                            :tag="'div'"
                                                            :custom-class="'border-color'"
                                                        ></app-moduleimage>
                                                        <app-moduleimage
                                                            v-if="[3].includes(module.layout.type)"
                                                            :data="image__value.data.image"
                                                            :tag="'div'"
                                                            :custom-class="'border-color'"
                                                        ></app-moduleimage>
                                                    </div>
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="album__inner-row module__inner-row" v-if="module.data.text2">
                        <div class="album__inner-col module__inner-col">
                            <div class="album__footer module__footer">
                                <div
                                    class="album__text module__text font-p color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text2"
                                    v-html="module.data.text2"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="album__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="album__inner-col module__inner-col">
                            <div
                                class="album__cta module__cta"
                                v-bind:class="{
                                    container__boxed: [1, 2, 3].includes(module.layout.type)
                                }"
                            >
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'album__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'album__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'album__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import { mapGetters } from 'vuex';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleButton from '@/components/assorted/ModuleButton';
import { SliderMixin } from '@/mixins/SliderMixin';
import Album from '@/external/modules/Album';

export default {
    data() {
        return {
            activeThumbnailIndex: 0
        };
    },
    components: {
        'app-moduleimage': ModuleImage,
        'app-modulebutton': ModuleButton
    },
    mixins: [SliderMixin],
    methods: {
        setPreviewImageIndex(index = 0) {
            if (this.getThumbnailsCount === 0) {
                return (this.activeThumbnailIndex = 0);
            }

            this.activeThumbnailIndex =
                index >= this.getThumbnailsCount - 1 ? this.getThumbnailsCount - 1 : index;
        }
    },
    computed: {
        ...mapGetters(['getPageUrlFromId', 'generateMediaUrl']),
        items() {
            return toArray(this.module.data.slides)
                .filter((i) => i.visible)
                .sort((a, b) => a.pos - b.pos);
        },
        imagesInFourGroups() {
            let res = [];
            for (var i = 0; i < this.items.length; i = i + 4) res.push(this.items.slice(i, i + 4));
            return res;
        },
        imagesInNineGroups() {
            let res = [];
            for (var i = 0; i < this.items.length; i = i + 9) res.push(this.items.slice(i, i + 9));
            return res;
        },
        getPreviewImageIndex() {
            return this.activeThumbnailIndex;
        },
        getThumbnailsCount() {
            return this.items && Array.isArray(this.items) && this.items.length > 0
                ? this.items.length
                : 0;
        }
    },
    mounted() {
        let i = new Album();
        i.init(this.$refs.root);
    },
    updated() {
        this.setPreviewImageIndex(this.getPreviewImageIndex);
    },
    props: {
        module: Object
    }
};
</script>
